export const getParams = (paramKey) => {
  const urlParams = new URLSearchParams(window.location.search);
  const param = urlParams.get(paramKey);
  return param;
};



// WEBPACK FOOTER //
// ./src/utils/getParams.js